import { render, staticRenderFns } from "./addGameGroup.vue?vue&type=template&id=6ba9e752&"
import script from "./addGameGroup.vue?vue&type=script&lang=js&"
export * from "./addGameGroup.vue?vue&type=script&lang=js&"
import style0 from "./addGameGroup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\sdk_manage_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ba9e752')) {
      api.createRecord('6ba9e752', component.options)
    } else {
      api.reload('6ba9e752', component.options)
    }
    module.hot.accept("./addGameGroup.vue?vue&type=template&id=6ba9e752&", function () {
      api.rerender('6ba9e752', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/packagingManagement/components/addGameGroup.vue"
export default component.exports